import { CopyTagTypes, type OperationDefinition } from '@/levity/flows/types';

import { CUSTOM } from '../constants';

type GenerateOperationKeys = 'CustomAiText';

export const customAiOperationsDefinition: Record<GenerateOperationKeys, OperationDefinition> = {
  CustomAiText: {
    id: 'llm-custom-ai-text',
    name: 'Custom AI',
    description: 'Custom AI',
    icon: 'custom',
    hasDynamicInputs: true,
    requiresAuth: false,
    copies: {
      operationContext: {
        title: 'Custom AI block',
      },
      interactiveParameters: {
        label: 'Input',
        title: 'Generate output',
        tooltips: {
          description:
            'Generate a custom output based on this input. You can select information from previous steps of this flow.',
        },
      },
      actionDefinition: {
        customTags: [{ type: CopyTagTypes.CURRENT_NODE_INPUTS }],
        elementTags: [],
        action: `Produce output based on ${CUSTOM}`,
      },
    },
  },
};
